const faqData = [
  {
    category: "General",
    question: "What is LostNFound?",
    answer:
      "LostNFound is the interface of a decentralized exchange network that allows people to trade, gift, or exchange plants, seeds, tools, materials, land, services, and more under its own Principles and Guidelines of Exchange."
  },
  {
    category: "General",
    question: "How do I join the LostNFound network?",
    answer:
      "Create a profile, agree to the one-page membership agreement, and you’re in. Members can post trades, add and edit plant dossiers for review, borrow tools where available, and participate in the wider exchange."
  },
  {  category: "General",
    question: "What is permaculture?",
    answer:
      "Permaculture is the gardening or cultivation practice of planting many species together in a way that mimics natural ecosystems, namely using many trees and perennial plants as well as soil building and nitrogen fixing plants, flowers everywhere to attract pollinators and beneficial insects, and using water wisely. It’s a holistic approach to land stewardship that focuses on long-term health and resilience."
  },
  {
    category: "General",
    question: "Is there a fee to join?",
    answer:
      "No. Membership is free. This network exists to build community and share resources whenever possible."
  },
  {
    category: "General",
    question: "Where is LostNFound available?",
    answer:
      "We’re currently based in Missouri and Illinois, especially around St. Charles and St. Louis, and growing outward. Even if you’re outside the core area, reach out—we can often help you out still."
  },
  {
    category: "General",
    question: "How can I help propagate LostNFound in my area?",
    answer:
      "Spread the word, add your areas native plants to the Codex, and if you have the space, consider becoming a Node to steward local exchanges."
  },
  {
    category: "Trading",
    question: "Is there anything I can’t trade?",
    answer:
      "Yes. We don’t allow items known to harm land or community health: invasive species, diseased plant or soil material, and harmful artificial chemicals like certain pesticides or herbicides. If it cant be made without a lab or factory, it should not be going in our food or soil."
  },
  {
    category: "Trading",
    question: "What if there are no trades in my area?",
    answer:
      "The network might still be growing near you. Expand your search radius, post what you’re seeking, or start a local LostNFound group to find nearby stewards."
  },
  {
    category: "Trading",
    question: "How do I ensure safe and successful trades?",
    answer:
      "Communicate clearly about what is being exchanged and where you’ll meet. Value is set by the participants, so mutual consent and clarity make the exchange fair."
  },
  {
    category: "Technical",
    question: "How do I create a profile?",
    answer:
      "Go to Profile, enter your details, and agree to the membership agreement. Your mark and contact preferences will be saved to your profile."
  },
  {
    category: "Technical",
    question: "How do I add a plant to the Codex?",
    answer:
      "In Plants, choose Add Plant and fill in the dossier with as much detail as possible. Include images if you have them. Submissions are reviewed before they appear."
  },
  {
    category: "Technical",
    question: "Who do I contact for support?",
    answer:
      "Use the contact details on the homepage or message through an order on the Stock & Exchange Register."
  }
];

const createFaqItem = (faq) => {
  const details = document.createElement("details");
  details.className = "faq-item";

  const summary = document.createElement("summary");
  summary.textContent = faq.question;

  const body = document.createElement("div");
  body.className = "faq-answer";
  body.textContent = faq.answer;

  details.append(summary, body);
  return details;
};

const renderFaqs = (filterText = "") => {
  const list = document.getElementById("faqList");
  const statusEl = document.getElementById("faqStatus");
  if (!list) return;

  const query = filterText.trim().toLowerCase();
  const filtered = faqData.filter((faq) => {
    if (!query) return true;
    const haystack = `${faq.category} ${faq.question} ${faq.answer}`.toLowerCase();
    return haystack.includes(query);
  });

  list.innerHTML = "";
  const categories = new Map();
  filtered.forEach((faq) => {
    if (!categories.has(faq.category)) categories.set(faq.category, []);
    categories.get(faq.category).push(faq);
  });

  if (filtered.length === 0) {
    const empty = document.createElement("p");
    empty.className = "muted";
    empty.textContent = "No matches. Try different keywords like node, trade, membership, or plants.";
    list.appendChild(empty);
  } else {
    categories.forEach((items, category) => {
      const wrapper = document.createElement("div");
      wrapper.className = "faq-category";

      const heading = document.createElement("h3");
      heading.textContent = category;
      wrapper.appendChild(heading);

      items.forEach((faq, index) => {
        const item = createFaqItem(faq);
        if (!query && index === 0) item.setAttribute("open", "open");
        wrapper.appendChild(item);
      });

      list.appendChild(wrapper);
    });
  }

  if (statusEl) {
    const total = faqData.length;
    statusEl.textContent = query
      ? `Showing ${filtered.length} of ${total} answers for “${filterText.trim()}”.`
      : `Showing ${total} answers.`;
  }
};

const debounce = (fn, wait = 180) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
};

document.addEventListener("DOMContentLoaded", () => {
  const search = document.getElementById("faqSearch");
  renderFaqs();

  if (search) {
    const onChange = debounce(() => renderFaqs(search.value || ""));
    search.addEventListener("input", onChange);
  }
});
